import React, { useContext, useState } from 'react'
import { DataContext } from '../../Context';
import { MdOutlineDeleteOutline } from "react-icons/md";

function ProductViewArmaTuPc({id,nombre,imagen,precio, addToCart, descuento, categoryId, selected, valueFinal, stock}) {
    const baseImage = "https://72jjtpdj.directus.app/assets/";
    const {errorDolarAPI} = useContext(DataContext);
    const {
            setCount,
            count,
            setIsSelected,
            setIdProduct,
            setCartItem,
            CartItem
          } = useContext(DataContext);
    const crearProducto = (nombre, descuento, imagen, id, precio, categoryId) => {
      let productItem = {
        imagen,
        descuento,
        id,
        nombre,
        precio,
        categoryId
      }
      addToCart(productItem);
      setIdProduct(id);
    }

    const eliminarProducto = (id) => {
      setCartItem(CartItem.filter((item) => item.id !== id));
    }

  const incrementCount = () => {
    setCount(count + 1);
    setIsSelected(true)
  }

  return (
    <div  className={selected ? "item-container-product-selected" : stock  === 0 ? "item-container-product-outofstock" : "item-container-product"}  onClick={selected ? null : stock === 0 ? null : ()=> [crearProducto(nombre, descuento, imagen, id, parseInt(valueFinal) - (parseInt(descuento) * parseInt(valueFinal) / 100), categoryId), incrementCount()]}>
        {/* {selected ? <h2>Seleccionado</h2> : null} */}
        {descuento > 0 ? <span className="discount">{descuento}% Off</span> : null}
        <div className="img_container_card">
          <img src={baseImage+imagen} alt={nombre} />
        </div>
        <h3>{nombre}</h3>
        {
          selected ? 
          <p className='producto_seleccionado_p'>Producto Seleccionado</p>
          :  stock === 0 ?  <p className='producto_sinstock'>Sin Stock</p> : descuento > 0 ? <h4>Precio: <strike> {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(valueFinal)}</strike></h4> : <h4>Precio: {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(valueFinal)}</h4>
        }
        {
          selected ?
          <>
          {descuento > 0 ? <h4>Precio:  {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(precio)}</h4> : <h4>Precio: {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(precio)}</h4>}
          </>
          :  stock === 0 ?  null :
          descuento > 0 ? <h4>Ahora: {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(parseInt(valueFinal) - (parseInt(descuento) * parseInt(valueFinal) / 100))} </h4> : null
        }
        {selected ? <MdOutlineDeleteOutline className='icon-delete-armatupc' onClick={() => eliminarProducto(id)} >Eliminar</MdOutlineDeleteOutline> : null}
    </div>
  )
}

export default ProductViewArmaTuPc